import { createContext, useMemo } from "react";
import { Outlet } from "react-router";
import Loading from "components/shared/Loading";
import useGraphQLQuery from "hooks/api/GQL";
import queryConfig from "hooks/api/GQL/queryConfig";
import useCurrentUser from "hooks/api/REST/user/useCurrentUser";
import { ILegalAcknowledgementData } from "models/legalAcknowledgement.models";
import { TUser } from "models/users.models";

export type TLegalAcknowledgementContextType = {
  legalAcknowledgements: ILegalAcknowledgementData[] | undefined;
  user: TUser | undefined;
};

export const LegalAcknowledgementContext = createContext<
  TLegalAcknowledgementContextType | undefined
>(undefined);

export const LegalAcknowledgementProvider = () => {
  const {
    data: legalAcknowledgements,
    isSuccess: isLegalAcknowledgementsSuccess,
  } = useGraphQLQuery(queryConfig.getLegalAcknowledgements);

  const { user, isSuccess: isUserSuccess } = useCurrentUser();

  const value = useMemo(
    () => ({ legalAcknowledgements, user }),
    [legalAcknowledgements, user],
  );

  return (
    <LegalAcknowledgementContext.Provider value={value}>
      {isLegalAcknowledgementsSuccess && isUserSuccess ? (
        <Outlet />
      ) : (
        <Loading />
      )}
    </LegalAcknowledgementContext.Provider>
  );
};
